import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { convertLegacyEntityCardExtension } from '@backstage/plugin-catalog-react/alpha';
import {
  isGitlabAvailable,
  EntityGitlabReadmeCard,
  EntityGitlabCoverageCard,
  EntityGitlabReleasesCard,
  EntityGitlabMergeRequestStatsCard,
  EntityGitlabPeopleCard,
  EntityGitlabLanguageCard,
  EntityGitlabIssuesTable,
  EntityGitlabPipelinesTable,
  EntityGitlabMergeRequestsTable,
} from '@immobiliarelabs/backstage-plugin-gitlab';

// The upstream gitlab plugin's alpha cards (readme, coverage, releases, etc.)
// ship with no entity filter, so they try to render — and fail with "wrong
// project_slug or project_id" — on every entity, including our AWS
// Innovation Sandbox Resource entities (aws-sandbox-lease/-account/-template)
// which have no gitlab.com/project-slug annotation and never will.
//
// Re-declaring each card under the plugin's own id ("gitlab") + its original
// name overrides it in place and adds the same isGitlabAvailable filter the
// plugin's own "Gitlab" entity tab already uses.
const cardOverrides = [
  { name: 'readme', Component: EntityGitlabReadmeCard },
  { name: 'coverage', Component: EntityGitlabCoverageCard },
  { name: 'releases', Component: EntityGitlabReleasesCard },
  { name: 'merge-requests-stats', Component: EntityGitlabMergeRequestStatsCard },
  { name: 'people', Component: EntityGitlabPeopleCard },
  { name: 'languages', Component: EntityGitlabLanguageCard },
  { name: 'issues-table', Component: EntityGitlabIssuesTable },
  { name: 'pipelines-table', Component: EntityGitlabPipelinesTable },
  { name: 'merge-requests-table', Component: EntityGitlabMergeRequestsTable },
].map(({ name, Component }) =>
  convertLegacyEntityCardExtension(Component, { name, filter: isGitlabAvailable }),
);

export const gitlabCardFiltersModule = createFrontendModule({
  pluginId: 'gitlab',
  extensions: cardOverrides,
});
